import { Box, useMediaQuery } from "@chakra-ui/react";

import { WarningWidget } from "components/Widgets";
import { ChakraText } from "components/ChakraText";

import { ExpiredAppointmentsTable } from "./ExpiredAppointmentsTable";
import { useGetPaginatedUserAppointments } from "../../../infrastructure/useGetPaginatedUserAppointments";
import { ExpiredAppointmentsMobile } from "./ExpiredAppointmentsMobile";

const ExpiredAppointments = () => {
  const [isMobile] = useMediaQuery("(max-width: 967px)");
  const limit = 6;
  const { data } = useGetPaginatedUserAppointments({
    limit: limit,
    offset: 0,
    expired: true,
  });

  if (!data) {
    return <></>;
  }

  if (data.total === 0) {
    return (
      <WarningWidget>
        <ChakraText fontSize={{ base: "xl", md: "2xl" }} alignSelf="center">
          Brak historycznych wizyt
        </ChakraText>
      </WarningWidget>
    );
  }

  return (
    <Box mt={4}>
      {isMobile ? (
        <ExpiredAppointmentsMobile
          totalAppointments={data.total}
          limit={limit}
        />
      ) : (
        <ExpiredAppointmentsTable
          totalAppointments={data.total}
          limit={limit}
        />
      )}
    </Box>
  );
};

export { ExpiredAppointments };
